<template>
  <div class="ui basic fluid center aligned segment">
    <h1 class="ui header">Uh-Oh!
      <div class="sub header">{{ error }}</div>
    </h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Error',
  computed: {
    ...mapGetters(['error']),
  },
};
</script>
